let cestamoi = function ($) {

	function init () {
		filterSilder(),
		singleProductTabs(),
		variableInputAddons(),
		attentionAllergies(),
		menuToggleDropdown(),
		addonButtonsQTY()
	}

	function menuToggleDropdown () {
		const topLevelMenuItems = $('#menu-the-offcanvas-menu .menu-item-has-children').find('a:first')
		topLevelMenuItems.click(function (event) {
			event.preventDefault()
			event.stopPropagation()
			$(this).parent().toggleClass('active')
		})
	}

	function filterSilder () {
		const filters = $('.product-filters')
		const arrows = $('.arrow')
		arrows.click(function (event) {
			event.preventDefault()
			event.stopPropagation()
			const currentPosition = filters.scrollLeft()
			if ($(this).hasClass('right')) {
				filters.animate({
					scrollLeft: currentPosition + 200,
				}, 250)
			} else {
				filters.animate({
					scrollLeft: currentPosition - 200,
				}, 250)
			}
		})
	}

	function singleProductTabs () {
		const tabs = $('.info-tab')

		$('.description').addClass('active')
		tabs.first().addClass('active')

		tabs.click(function (event) {
			event.preventDefault()
			event.stopPropagation()
			if (!$(this).hasClass('active')) {
				const content = $(this).attr('tab')

				$('.product-content').removeClass('active')
				tabs.removeClass('active')
				$(this).addClass('active')

				$(`.${content}`).addClass('active')
			}
		})
	}

	function attentionAllergies () {
		const noAllergies = $('#sans-allergenes')
		const otherAllergies = $('.attention-allergies-option input').not('#sans-allergenes')
		$('.attention-allergies-option input').click(function (event) {
			if ($(this).is(noAllergies)) {
				if ($(this).is(':checked')) {
					otherAllergies.prop('checked', false)
					otherAllergies.parent().addClass('disabled')
					otherAllergies.attr('disabled', true)
				} else {
					otherAllergies.parent().removeClass('disabled')
					otherAllergies.removeAttr('disabled')
				}
			} else {
				if (otherAllergies.is(':checked')) {
					noAllergies.prop('checked', false)
					noAllergies.parent().addClass('disabled')
					noAllergies.attr('disabled', true)
				} else {
					noAllergies.parent().removeClass('disabled')
					noAllergies.removeAttr('disabled')
				}
			}
		})

	}

	function variableInputAddons () {

		const variableQuantityInput = $('.variable-addon').find('.cestamoi-product-customization-price-modifier-input')
		const variableTextContainers = $('.text-inputs-container').find('.input-container')

		// hide all text containers and show 1 be default
		variableTextContainers.addClass('hidden')
		variableQuantityInput.val(1)
		variableTextContainers.slice(0, variableQuantityInput.val()).removeClass('hidden')


		variableQuantityInput.change(function () {

			// hide all containers and reveal the number the user specified
			variableTextContainers.addClass('hidden')
			variableTextContainers.slice(0, variableQuantityInput.val()).removeClass('hidden')

			// loop through hidden containers and empty their contents
			variableTextContainers.each(function () {
				if ($(this).hasClass('hidden')) {
					$(this).find('input').val('')
					$(this).find('.text-input-limit').text('0 sur 30 caractères maximum')
				}
			})

		})

		$('.variable-text-field').on('input', function () {
			const textLength = $(this).val().length
			$(this).siblings('.text-input-limit').text(`${textLength} sur 30 caractères maximum`)
		})
	}

	function addonButtonsQTY () {
		$('.addon-number-field').each(function () {
			const $field = $(this);
			const $input = $field.find('input');
			const $increment = $field.find('.increment');
			const $decrement = $field.find('.decrement');

			const $toggle = $field.find('.qty-toggle');
			const $fieldsWrapper = $field.find('.qty-fields-wrapper');

			// Hide from start for smoother transition
			$fieldsWrapper.hide();

			function hideInput () {
				let value = parseInt($input.val() || 0, 10);
				if (value == 0) {
					$input.unbind('change', hideInput);
					setTimeout(
						function () {
							$fieldsWrapper.fadeOut(200, function () {
								$toggle.delay(50).fadeIn(200);
							});
							$input.val(0).trigger('change'); // Make sure the value is still 0 since there is a delay before hiding
						},
						1000);
				}
			}


			$toggle.on('click', function (event) {
				$input.bind('change', hideInput);
				$input.val(1).trigger('change'); // Update value and trigger change event		
				$toggle.fadeOut(200, function () {
					$fieldsWrapper.delay(50).fadeIn(200);
				});
			});

			$increment.on('click', function () {
				let value = parseInt($input.val() || 0, 10);
				$input.val(value + 1).trigger('change'); // Update value and trigger change event
			});

			$decrement.on('click', function () {
				let value = parseInt($input.val() || 0, 10);
				if (value > 0) {
					$input.val(value - 1).trigger('change'); // Update value and trigger change event
				}
			});

		});
	}

	jQuery('.product-image-slider').slick({
		dots: true,
		infinite: false,
		speed: 1000,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		customPaging: function (slider, i) {
			var hasApercu = $('.product-image-slide.product-preview').length;
			if (i == 0 && hasApercu) return '<a class="product-preview-link">Aperçu *</a>';
			return '<a>' + ((hasApercu) ? i : (i + 1)) + '</a>';
		},
		prevArrow: "<button type='button' class='slick-prev'></button>",
		nextArrow: "<button type='button' class='slick-next'></button>",
		appendArrows: '.slider-nav', appendDots: '.slider-nav'
	});

	// Cart button to load customization from JSON
	$('.btn-apply-customization').on('click', function (e) {
		e.preventDefault();
		let json = JSON.parse($(this).attr('data-customization-json'));
		$.each(JSON.parse(json), function (key, value) {
			localStorage.setItem('customization-' + key, value);
		});
		if ($(this).attr('target') == '_blank') {
			window.open($(this).attr('href'));
		} else {
			window.location.href = $(this).attr('href');
		}
	});

	// Cart button to clear all customizations
	$('.btn-clear-customization').on('click', function (e) {
		e.preventDefault();
		let customizationKeys = ['text', 'back-text', 'couleur-texte', 'couleur-fond', 'style', 'police'];
		customizationKeys.forEach(function (key) {
			localStorage.removeItem('customization-' + key);
		});
		window.location.href = $(this).attr('href');
	});


	function applyEditChoices () {
		const urlParams = new URLSearchParams(window.location.search);
		if (urlParams.has('edit_item')) {
			urlParams.forEach((value, key) => {
				
				if (key.startsWith('addon_')) {
					key = key.split("_")[1];
					let brackets = splitBrackets(key);
					if (brackets) {
						let input = $('[name="addons[' + brackets['before'] + '][' + brackets['inside'] + ']');
						input.trigger('click');
						input.val(value).trigger('change');
					} else {
						let input = $('[name="addons[' + key + ']"]');
						$(input).parents('.addon-number-field').find('.qty-toggle').trigger('click');
						input.val(value).trigger('change');
					}	
				}

				// Apply selected variation
				if (key.startsWith('attribute_')) {
					let variation_ul = $('ul[data-attribute_name="' + key + '"]');
					let variation_swatch = $('.select-option.swatch-wrapper[data-attribute="' + key + '"][data-value="' + value + '"]');
					if (variation_ul.length > 0) {
						variation_ul.find('input[value="' + value + '"]').click();
					} else if (variation_swatch.length > 0) {
						variation_swatch.click();
					}
				}
			})
		}
	}

	function splitBrackets(str) {
		const re = /^(.+?)\[(.+?)\]$/;
		const m  = str.match(re);
		if (!m) return false;  // no brackets in the expected format
		// m[1] is “before”, m[2] is “inside”
		return { before: m[1], inside: m[2] };
	}

	return {
		init,
		applyEditChoices
	}

}(jQuery)


document.addEventListener('DOMContentLoaded', function (event) {
	cestamoi.init();
})

jQuery(window).load(function(){
	cestamoi.applyEditChoices();
});